import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import PageHeader from 'components/PageHeader/PageHeader';
import { useEffect, useState } from 'react';
import { getOrganizations } from 'services/organisation.service';
import { getImpactReportTemplates } from 'services/impactReportTemplate.services';
import { getImpactReportModels } from 'services/impactReportModel.services';
import CreateImpactReportSchedulingForm from 'components/CreateImpactReportSchedulingForm/CreateImpactReportSchedulingForm';

export default function CreateImpactReportSchedulingPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const impactReportId = id || '';

  const [organisationList, setOrganisationList] = useState([]);
  useEffect(() => {
    getOrganizations().then((response) => {
      setOrganisationList(response.data);
    });
  }, []);

  const [impactReportTemplateList, setImpactReportTemplateList] = useState([]);
  useEffect(() => {
    getImpactReportTemplates().then((response) => {
      setImpactReportTemplateList(response.data);
    });
  }, []);

  const [impactReportModelList, setImpactReportModelList] = useState([]);
  useEffect(() => {
    getImpactReportModels().then((response) => {
      setImpactReportModelList(response.data);
    });
  }, []);

  return (
    <Container>
      <PageHeader
        title={id ? t('createImpactReportSchedulingPage.titleModify') : t('createImpactReportSchedulingPage.titleCreate')}
        hasButton={false}
        hasBackButton={true}
      />
      <CreateImpactReportSchedulingForm  impactReportId={impactReportId} organisationList={organisationList}  impactReportTemplateList={impactReportTemplateList}  impactReportModelList={impactReportModelList} />
    </Container>
  );
}
